import { Component } from '@angular/core';

@Component({
  selector: 'tangram-lms-integration-panel',
  templateUrl: './lms-integration-panel.component.html',
  styleUrls: ['./lms-integration-panel.component.scss']
})
export class LmsIntegrationPanelComponent {
  providers = ['Canvas', 'Blackboard', 'Brightspace'];
  selectedProvider = 'Canvas';
  isConnected = false;
  isLoading = false;
  selectedCourseId = '';
  courses = [
    { id: 'course-1', title: 'Intro to Biology' },
    { id: 'course-2', title: 'World History 101' },
    { id: 'course-3', title: 'Data Analysis Fundamentals' }
  ];

  connect() {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
      this.isConnected = true;
    }, 1000);
  }
}
